import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../../../store';

/**
 * Select the theme state slice
 * Note: This assumes the theme state will be added to the RootState
 * This will be fixed when we update the store configuration
 */
export const selectThemeState = (state: RootState) =>
  (state as unknown as { core: { theme: { theme: string; isHighContrast: boolean; completeTheme: Record<string, unknown> } } }).core.theme;

/**
 * Select the current theme (light, dark, or system)
 */
export const selectTheme = createSelector([selectThemeState], themeState => themeState.theme);

/**
 * Select the complete theme object
 */
export const selectCompleteTheme = createSelector([selectThemeState], themeState => themeState.completeTheme);

/**
 * Select whether the current theme is dark
 */
export const selectIsDarkTheme = createSelector([selectTheme], theme => theme === 'dark');

/**
 * Select whether high contrast mode is enabled
 */
export const selectIsHighContrast = createSelector([selectThemeState], themeState => themeState.isHighContrast);
